import React from 'react';
import { Link } from 'react-router-dom';

export default function BrandLogo({ className = 'logo', variant, children = 'LoopVisitor' }) {
  const classes = ['brand-logo', className, variant === 'light' ? 'brand-logo-light' : ''].filter(Boolean).join(' ');
  return (
    <Link to="/" className={classes}>
      {children}
    </Link>
  );
}
